// screens/SavedScreen.js - Screen 6
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSync } from '../contexts/SyncContext';

export default function SavedScreen() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { syncStatus, syncNow } = useSync();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 50);
    syncNow();
  }, []);

  return (
    <div style={{
      minHeight: '100vh', minHeight: '100dvh',
      background: 'var(--bg-primary)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: 24, textAlign: 'center'
    }}>
      {/* Animated checkmark */}
      <div style={{
        width: 100, height: 100,
        background: 'linear-gradient(135deg, var(--accent-success), #28b36e)',
        borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 28,
        fontSize: '2.5rem',
        transform: visible ? 'scale(1)' : 'scale(0)',
        opacity: visible ? 1 : 0,
        transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.3s ease',
        boxShadow: '0 0 40px rgba(52,201,125,0.3)'
      }}>
        ✓
      </div>

      <h1 style={{
        fontSize: '2rem', marginBottom: 10,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        transition: 'all 0.35s ease 0.15s'
      }}>
        Session Saved!
      </h1>

      <p style={{
        color: 'var(--text-secondary)', fontSize: '1rem', marginBottom: 8,
        maxWidth: 320,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.35s ease 0.25s'
      }}>
        All photos have been saved successfully.
      </p>

      {/* Sync indicator */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, marginBottom: 40,
        fontSize: '0.875rem',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.35s ease 0.3s'
      }}>
        <div className="sync-dot" style={{
          background: syncStatus.pending > 0 ? 'var(--accent-warning)' : 'var(--accent-success)'
        }} />
        <span style={{ color: 'var(--text-muted)' }}>
          {syncStatus.pending > 0 ? `${syncStatus.pending} photo${syncStatus.pending > 1 ? 's' : ''} syncing to server...` : 'Synced to server ✓'}
        </span>
      </div>

      {/* Actions */}
      <div style={{
        display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 320,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.35s ease 0.35s'
      }}>
        <button className="btn btn-primary btn-full btn-xl" onClick={() => navigate('/new-order')}>
          📸 New Session
        </button>
        <button className="btn btn-secondary btn-full btn-lg" onClick={() => navigate(`/order/${orderId}`)}>
          View Order Details
        </button>
        <button className="btn btn-ghost btn-full" onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>
    </div>
  );
}
